// src/routes/clientRoutes.js
import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import ClientLayout from '../views/Client/ClientLayout';
import ClientsDashboard from '../views/Client/ClientsDashboard';
import ClientMessages from '../views/Client/ClientMessages';
import ClientProfile from '../views/Shared/ClientProfile';
import ClientInvoices from '../views/Client/ClientInvoices';
import ClientService from '../views/Client/ClientService';

const clientRoutes = [
  <Route
    key="clients"
    path="/clients"
    element={
      <ProtectedRoute allowedRoles={['client']}>
        <ClientLayout />
      </ProtectedRoute>
    }
  >
    <Route index element={<ClientsDashboard />} />
    <Route path="dashboard" element={<ClientsDashboard />} />
    <Route path="messages" element={<ClientMessages />} />
    <Route path="service" element={<ClientService />} />
    <Route path="profile" element={<ClientProfile />} />
    <Route path="invoices" element={<ClientInvoices />} />
    <Route
      path="timeline"
      element={
        <div className="text-center mt-10 text-gray-500">
          Selecciona un proyecto para ver su línea de tiempo.
        </div>
      }
    />
  </Route>,
];

export default clientRoutes;
